export class RegisterUnidentifiedPerson {
    get id() {
        return this.registerUnidentifiedPersonState.id;
    }
    get nidentifica() {
        return this.registerUnidentifiedPersonState.nidentifica;
    }
    get fecentrada() {
        return this.registerUnidentifiedPersonState.fecentrada;
    }
    get horainicio() {
        return this.registerUnidentifiedPersonState.horainicio;
    }
    get horafin() {
        return this.registerUnidentifiedPersonState.horafin;
    }
    get nagente() {
        return this.registerUnidentifiedPersonState.nagente;
    }
    get lugaridentificacion() {
        return this.registerUnidentifiedPersonState.lugaridentificacion;
    }
    get diligenciasidentificacion() {
        return this.registerUnidentifiedPersonState.diligenciasidentificacion;
    }
    get observaciones() {
        return this.registerUnidentifiedPersonState.observaciones;
    }
    get user_id() {
        return this.registerUnidentifiedPersonState.user_id;
    }
    get motivoidentificacion() {
        return this.registerUnidentifiedPersonState.motivoidentificacion;
    }
    set id(id) {
        this.registerUnidentifiedPersonState.id = id;
    }
    set nidentifica(nidentifica) {
        this.registerUnidentifiedPersonState.nidentifica = nidentifica;
    }
    set fecentrada(fecentrada) {
        this.registerUnidentifiedPersonState.fecentrada = fecentrada;
    }
    set horainicio(horainicio) {
        this.registerUnidentifiedPersonState.horainicio = horainicio;
    }
    set horafin(horafin) {
        this.registerUnidentifiedPersonState.horafin = horafin;
    }
    set nagente(nagente) {
        this.registerUnidentifiedPersonState.nagente = nagente;
    }
    set lugaridentificacion(lugaridentificacion) {
        this.registerUnidentifiedPersonState.lugaridentificacion = lugaridentificacion;
    }
    set diligenciasidentificacion(diligenciasidentificacion) {
        this.registerUnidentifiedPersonState.diligenciasidentificacion = diligenciasidentificacion;
    }
    set user_id(user_id) {
        this.registerUnidentifiedPersonState.user_id = user_id;
    }
    set observaciones(observaciones) {
        this.registerUnidentifiedPersonState.observaciones = observaciones;
    }
    set motivoidentificacion(motivoidentificacion) {
        this.registerUnidentifiedPersonState.motivoidentificacion = motivoidentificacion;
    }
    constructor(registerUnidentifiedPersonState) {
        this.registerUnidentifiedPersonState = registerUnidentifiedPersonState;
    }
    getState() {
        return this.registerUnidentifiedPersonState;
    }
}
